import { useRef, useState } from "react";
import { fmtDate, fmtTime, dayKey, addDays } from "@/lib/api";
import { SessionActions } from "@/components/SessionActions";
import { Avatar } from "@/components/Avatar";
import { StatusChip, Empty } from "@/components/ui-bits";

export const DayView = ({ days, sessions, dayIdx, setDayIdx, onDone, onAdd, onOpen }) => {
  const touch = useRef(null);
  const [dir, setDir] = useState("");
  const todayKey = new Date().toISOString().slice(0, 10);
  const day = days[dayIdx];
  const k = dayKey(day.toISOString());
  const list = sessions.filter((s) => dayKey(s.startAt) === k);
  const go = (n) => { const next = dayIdx + n; if (next < 0 || next > 6) return; setDir(n > 0 ? "left" : "right"); setDayIdx(next); };

  const onTouchStart = (e) => { touch.current = { x: e.touches[0].clientX, y: e.touches[0].clientY }; };
  const onTouchEnd = (e) => {
    if (!touch.current) return;
    const dx = e.changedTouches[0].clientX - touch.current.x, dy = e.changedTouches[0].clientY - touch.current.y;
    touch.current = null;
    if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy) * 1.5) go(dx < 0 ? 1 : -1);
  };

  return (
    <div data-testid="day-view">
      <div className="daystrip" style={{ marginBottom: 10 }}>
        {days.map((d, i) => {
          const dk = dayKey(d.toISOString());
          const n = sessions.filter((s) => dayKey(s.startAt) === dk).length;
          return (
            <button type="button" key={dk} className={`daybtn ${i === dayIdx ? "on" : ""} ${dk === todayKey ? "today" : ""}`} onClick={() => { setDir(i > dayIdx ? "left" : "right"); setDayIdx(i); }} data-testid={`dayview-day-${dk}`}>
              <small>{fmtDate(d.toISOString(), { weekday: "short" })}</small>
              <b>{fmtDate(d.toISOString(), { day: "numeric" })}</b>
              <small>{n ? `${n} sess` : "—"}</small>
            </button>
          );
        })}
      </div>
      <div className={`dayswipe ${dir}`} key={k} onTouchStart={onTouchStart} onTouchEnd={onTouchEnd} data-testid="dayview-panel">
        <div className="ph" style={{ marginBottom: 8 }}>
          <h3 style={{ fontSize: 15 }}>{fmtDate(day.toISOString(), { weekday: "long", day: "numeric", month: "long" })}{k === todayKey ? " · today" : ""}</h3>
          <div className="actions">
            <button className="btn g sm" onClick={() => go(-1)} disabled={dayIdx === 0} data-testid="dayview-prev">‹</button>
            <button className="btn g sm" onClick={() => go(1)} disabled={dayIdx === 6} data-testid="dayview-next">›</button>
            <button className="btn sm" onClick={() => onAdd(k)} data-testid="dayview-add">+ Add</button>
          </div>
        </div>
        {list.length === 0 && <Empty>No sessions — swipe or tap another day.</Empty>}
        {list.map((s) => (
          <div className="daycard" key={s.id} data-testid={`daycard-${s.id}`}>
            <div className="daycard-top" onClick={() => onOpen(s)}>
              <div className="daycard-time num">{fmtTime(s.startAt)}<small>{fmtTime(s.endAt)}</small></div>
              <Avatar client={{ id: s.clientId, photoKey: s.clientPhotoKey, name: s.clientName }} size={44} radius={11} />
              <div style={{ flex: 1, minWidth: 0 }}>
                <div className="st">{s.clientName}</div>
                <div className="ss">{s.title}{s.recoveryTotal != null ? ` · recovery ${s.recoveryDone}/${s.recoveryTotal}` : ""}{s.changeNote ? ` · wants: ${s.changeNote}` : ""}</div>
              </div>
              <StatusChip status={s.status} />
            </div>
            <SessionActions session={s} admin onDone={onDone} />
          </div>
        ))}
        <p className="ss" style={{ textAlign: "center", marginTop: 10 }}>Swipe left / right to change day</p>
      </div>
    </div>
  );
};

export const weekDays = (monday) => Array.from({ length: 7 }, (_, i) => addDays(monday, i));
